import { jwtDecode, JwtPayload } from 'jwt-decode';

export interface JWT extends JwtPayload {
  /** Access Token hash value */
  at_hash: string;
  /** Subject (whom the token refers to) */
  sub: string;

  /** Issuer (who created and signed this token) */
  iss: string;
  /** Time when authentication occurred */
  auth_time: number;
  /** Expiration time (seconds since Unix epoch) */
  exp: number;
  /** Issued at (seconds since Unix epoch) */
  iat: number;
  /** JWT ID (unique identifier for this token) */
  jti: string;
  /** Audience (who or what the token is intended for) */
  aud: string | string[];
}
export function parseJwt<T extends JWT = JWT>(token: string): T {
  return jwtDecode<T>(token);
}

/**
 * In the JWT token, dates like `iat` & `exp` are in seconds, while the standard Date class works with milliseconds.
 */
export function getJwtDate(jwtDate: number): Date {
  return new Date(jwtDate * 1000);
}
